export default "__VITE_ASSET__mb_4C7gY__"